import React, { useState } from 'react';
import { StyleSheet } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { sendItineraryApi } from '../../services/api/itinerary.service';
import { openAlert } from '../../store/actions/alert';
import {
  selectReceiptPassengers,
  selectFirstReceipt,
} from '../../store/selectors/mytrips.selector';
import { Color, CommonProperties, CommonStyles } from '../../styles';
import { validateEmail } from '../../utils/common.utils';
import BaseText from '../BaseText';
import BottomButton from '../BottomButton';
import WrapBottomColor from '../containers/WrapBottomColor';
import InputAnimated from '../InputAnimated';
import SwitchWithLabel from '../SwitchWithLabel';
import { useComponentTKey, i18nNS } from '../../i18n';
import { useTranslation } from 'react-i18next';
import { ScrollView } from 'react-native-gesture-handler';
const validateEmails = (emails) => {
  const arrayEmails = emails.split(',');
  return arrayEmails.every((email) => validateEmail(email));
};

const EmailItineraryModal = ({ navigation, route }) => {
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('EmailItineraryModal');
  const withPrice = route.params?.withPrice;
  const [emails, setEmails] = useState('');
  const isValid = validateEmails(emails);
  const [includePassenger, setIncludePassenger] = useState({});
  const passengers = useSelector(selectReceiptPassengers);
  const dispatch = useDispatch();
  const receiptResponse = useSelector(selectFirstReceipt);
  const onTogglePassenger = (passengerId) => {
    setIncludePassenger({
      ...includePassenger,
      [passengerId]: !includePassenger[passengerId],
    });
  };

  const onSubmit = async () => {
    const response = await sendItineraryApi(
      receiptResponse.TripId,
      withPrice ? 'with' : 'without',
      emails
    );

    if (response !== 'success') {
      dispatch(
        openAlert({
          message: 'We are not able to send your itinerary right now, please try again later',
        })
      );
    }

    navigation.goBack();
  };

  return (
    <WrapBottomColor disabled={!isValid}>
      <ScrollView style={styles.container}>
        <BaseText style={styles.title}>
          {withPrice ? t(tKey('SendItineraryWithPricing')) : t(tKey('SendItineraryWithoutPricing'))}
        </BaseText>
        <BaseText style={styles.text}>{t(tKey('SendItineraryOf'))}:</BaseText>
        {passengers.length > 1 ? <SwitchWithLabel left label={t(tKey('SelectAll'))} /> : null}
        {passengers.map((item, index) => (
          <SwitchWithLabel
            key={index}
            left
            label={`${item.FirstName} ${item.LastName}`}
            onChange={() => onTogglePassenger(item.Id)}
            value={includePassenger[item.Id]}
          />
        ))}
        <BaseText style={CommonStyles.my5}>
          {t(tKey('TheTravelerEmailAddressAppearsHereAs'))}
        </BaseText>
        <BaseText style={CommonStyles.my3}>{t(tKey('UseCommaToSeparate'))}</BaseText>
        <InputAnimated
          label={t(tKey('Emails'))}
          value={emails}
          onChangeText={(text) => setEmails(text)}
        />
      </ScrollView>
      <BottomButton label={t(tKey('Send'))} full onPress={onSubmit} disabled={!isValid} />
    </WrapBottomColor>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Color.accent,
    ...CommonProperties.p3,
  },
  title: {
    ...CommonProperties.py3,
    ...CommonProperties.h3,
    textAlign: 'center',
  },
  text: {
    ...CommonProperties.pt3,
    ...CommonProperties.h4,
  },
});

export default EmailItineraryModal;
